


































// import { isEmptyObject } from '@/utils/helpers';
import { PropType } from 'vue';
import events from '@/mixins/events';
import mixins from '@/utils/mixins';
import { Event } from '@/models/Event';

export default mixins(events).extend({
  name: 'DataEventCard',
  props: {
    event: {
      required: true,
      type: Object as PropType<Event>
    },
    current: {
      required: false,
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    show: false
  }),
  computed: {},
  methods: {
    selectEvent: async function(id: string) {
      if (!this.getEventById(id)) {
        this.fetchEvent(id).then(() => {
          if (this.current) {
            this.getCurrentEvent = id;
          }
        });
      }
      await this.$nextTick(() => {
        localStorage.setItem('current__event', id);
      });
      this.$router.push({
        name: `event-detail`,
        params: { id }
      });
    }
  }
});
